import axios from 'axios'
import { axiosManager } from './axiosManager'

const API_URL = process.env.REACT_APP_HOST_API

export const registerAsGuest = async (sessionId, firstName = null) => {
  try {
    // A bound on the wait, so a server that never answers ends in the button's "Failed to
    // join as guest. Please try again." instead of a spinner for good. Not retried here: a
    // request that timed out may still have created the guest.
    const response = await axios.post(`${API_URL}/registerGuest`, {
      sessionId,
      firstName
    }, { timeout: 30000 })

    // Store the token for future API calls
    localStorage.setItem('token', response.data.token)
    // Login.jsx navigates client-side after this resolves, so AuthContext never
    // remounts and checkAuth() never re-runs - without this, a freshly-joined
    // guest's axiosInstance carries no Authorization header until they reload.
    axiosManager.setAuthToken(response.data.token)

    return {
      user: response.data.user,
      token: response.data.token
    }
  } catch (error) {
    console.error('Error registering guest:', error)
    throw error
  }
}

export const isGuestUser = (user) => {
  return user && !user.email && !user.password
}